module.exports = __webpack_public_path__ + "static/media/welcome-mobile.22d2dc88585e1e45575c8c208e9f20ad6eb96957820e5ba670091e987cbb6488.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/new-website-popup/welcome-mobile.png
// module id = 2341
// module chunks = 204